import React, { useEffect, useState } from "react";
import { getMarketOverview } from "../api";

const REFRESH_MS = 60000;

export default function MarketTicker() {
  const [indices, setIndices] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      getMarketOverview()
        .then((d) => { if (!cancelled) setIndices(d.indices || []); })
        .catch(() => {}); // stay quiet in the top bar — Dashboard surfaces real errors
    };
    load();
    const id = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const shown = (indices || []).filter((idx) => idx.symbol !== "^DJI");
  if (shown.length === 0) return null;

  return (
    <div className="hidden lg:flex items-center gap-4 px-1 shrink-0 overflow-x-auto max-w-md">
      {shown.map((idx) => {
        const isPos = (idx.change ?? 0) >= 0;
        return (
          <div key={idx.symbol} className="flex items-baseline gap-1.5 text-xs whitespace-nowrap">
            <span className="font-medium" style={{ color: "var(--text-muted)" }}>{idx.name}</span>
            <span className="font-semibold" style={{ color: "var(--text-primary)" }}>
              {idx.price?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
            <span style={{ color: isPos ? "var(--gain-green)" : "var(--loss-red)" }}>
              {isPos ? "+" : ""}{idx.change_pct?.toFixed(2)}%
            </span>
          </div>
        );
      })}
    </div>
  );
}
